// | ------------------------------------------------------------------------
// | Bootstrap - OffCanvas
// | ------------------------------------------------------------------------ 



// | ------------------------------------------------------------------------ 

document.addEventListener( 'DOMContentLoaded', function() {

    // Prevents site header and cookie popup from jumping around when offcanvas is opened

    const offCanvases = document.querySelectorAll('.offcanvas')

    offCanvases.forEach(e => {
      e.addEventListener('show.bs.offcanvas', event => {
        document.querySelector("body").classList.toggle('offcanvas-open');
      })     
      e.addEventListener('hidden.bs.offcanvas', event => {
        document.querySelector("body").classList.toggle('offcanvas-open');
      })  

    });   

});